import BlinketLogo from 'assets/images/new-blinket-logo.svg';

import { LoaderLine } from './Line';
import styles from './styles.module.css';

const GlobalLoading = () => {
  return (
    <div id='page-loader' className={styles.root}>
      <div className={styles.content}>
        <img src={BlinketLogo} alt='Blinket' className={styles.logo} />
        <LoaderLine />
      </div>
    </div>
  );
};

export default GlobalLoading;
